import LangSwitcher from './LangSwitcher';

export default LangSwitcher;
